var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwardBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "-5 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interface-Light"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interface-light-award-medal"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1 29.5 10 23.5 19 29.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1,
    x2: 4,
    y1: 29.5,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19,
    x2: 16,
    y1: 29.5,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10,
    cy: 10,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.49,4.85l.91,2.59a.52.52,0,0,0,.46.36l2.64.11a.54.54,0,0,1,.3,1l-2.07,1.71a.58.58,0,0,0-.18.57l.72,2.66a.53.53,0,0,1-.79.6l-2.19-1.54a.51.51,0,0,0-.58,0L7.52,14.41a.53.53,0,0,1-.79-.6l.72-2.66a.58.58,0,0,0-.18-.57L5.2,8.87a.54.54,0,0,1,.3-1L8.14,7.8a.52.52,0,0,0,.46-.36l.91-2.59A.52.52,0,0,1,10.49,4.85Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardBadge);
export default __webpack_public_path__ + "static/media/award-badge.edd61d45cbce38dd3673d5d30e02d0c4.svg";
export { ForwardRef as ReactComponent };